<template>
  <section class="container max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
    <Titre textePrincipal="Être famille d'" texteAccentue="accueil" :isSidebarOpen="isSidebarOpen" />
    <div
      class="flex flex-row flex-wrap justify-center mb-20 w-full mx-auto p-4 sm:mt-10 bg-gradient-to-r rounded-lg shadow-sm">

      <SectionCard v-for="(section, index) in sections" :key="index" :title="section.title" :content="section.content"
        :imageSrc="section.imageSrc" :imageAlt="section.imageAlt" :imageTitle="section.imageTitle"
        :imagePosition="section.imagePosition" :extraContent="section.extraContent">
        <!-- Slot image personnalisé -->
      </SectionCard>

      <div class="mx-auto flex flex-col items-start justify-center w-full p-4">
        <router-link to="/adoption"
          class="bg-action hover:bg-primaire shadow-lg text-white font-bold py-2 px-4 rounded-full transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primaire focus:ring-opacity-50 inline-block text-center" aria-label="En savoir plus sur l'adoption" title="En savoir plus sur l'adoption">
          En savoir plus !
        </router-link>

      </div>
    </div>
  </section>
</template>

<script setup>
import Titre from '../composants/Titre.vue';
import SectionCard from '../composants/SectionCard.vue';
import { isSidebarOpen } from '../store/storeSideBar.js';

import imgAnimaux3 from '../assets/images/animaux_de_la_seconde_chance_3.webp';
import imgAnimaux5 from '../assets/images/animaux_de_la_seconde_chance_5.webp';
import imgAnimaux4 from '../assets/images/animaux_de_la_seconde_chance_4.webp';
import imgAnimaux6 from '../assets/images/animaux_de_la_seconde_chance_6.webp';
import imgAnimaux7 from '../assets/images/animaux_de_la_seconde_chance_7.webp';

const sections = [
  {
    title: "Êtes-vous prêt à faire une différence dans la vie d'un chat ?",
    content: [
      `Notre organisme est constamment à la recherche de familles d'accueil prêtes à offrir un foyer chaleureux à des chats et chatons en attente d'adoption. En devenant famille d'accueil, vous avez la chance d'aider ces animaux vulnérables et de contribuer à leur bien-être.`,
    ],
    imageSrc: imgAnimaux3,
    imageAlt: 'logo',
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'right',
  },
  {
    title: 'Comment cela fonctionne ?',
    content: [
      `<b>Localisation</b> : Pour devenir famille d'accueil, vous devez résider dans la région de Matane.`,
      `<b>Espace requis</b> : Une pièce libre est nécessaire pour isoler le chat pendant au moins 24 heures, afin de garantir l'élimination des puces et/ou des mites. Lors de la récupération du chat, une responsable vous fournira une dose de «&nbsp;révolution&nbsp;» pour vous rendre aux rendez-vous vétérinaires. Vos propres chats doivent être stérilisés et, de préférence, vaccinés.`,
    ],
    imageSrc: imgAnimaux5,
    imageAlt: "3 chats noirs dans les marches d'escalier",
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'left',
  },
  {
    title: 'Pour combien de temps ?',
    content: [
      `Pour aussi longtemps que vous le voudrez. Ce n'est pas une obligation et toutes nos familles d'accueil le font sur une base volontaire. Le nombre de chats placés dans chaque famille varie également selon les critères de chacun. Un délai minimum de 6 mois est demandé. Nous ne pouvons pas garantir le délais d’adoption pour un chat.`,
    ],
    imageSrc: imgAnimaux4,
    imageAlt: 'chaton sur le dos',
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'right',
  },
  {
    title: "Et si j'ai des questions ?",
    content: [
      `Nous sommes une petite communauté très sympathique et nous aimons nous entraider. En devenant famille d'accueil, vous pourrez joindre notre groupe sur Facebook et recevoir du support et des réponses si vous en avez besoin.`,
    ],
    imageSrc: imgAnimaux6,
    imageAlt: 'Point d\'interrogation',
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'left',
  },
  {
    title: "J'ai de la place et j'aimerais tenter l'aventure. Que dois-je faire ?",
    content: [
      `Si vous êtes intéressés à joindre notre groupe et que vous demeurez à Matane ou dans les environs, vous pouvez communiquer avec nous par <a href='mailto:info@animauxdelasecondechance.com?subject=Info%20adoption' class='text-navigation hover:underline font-bold'>courriel</a> et la personne qui s'occupe des familles vous contactera.`,
    ],
    imageSrc: imgAnimaux7,
    imageAlt: 'chaton sur un tapis',
    imageTitle: 'Animaux de la seconde chance',
    imagePosition: 'right',
  },

]

</script>